<template>
  <div class="report content-padding">
    <h2>Создание отчета</h2>
    Выберите объект
    <div class="row">
      <div class="col-12 col-md-8">
        <report-tree @loadChild="loadChild" :elements="housesTree">
          <template v-slot:title="{element, id}">
            <div class="tree-text" :class="{'selected': selectedElement.id === id}">
              <button class="btn" @click="onTreeClick(id, element)">{{ element.name }}</button>
            </div>
          </template>
        </report-tree>
      </div>
      <div class="col-12 col-md-4">
        <div class="report-object-info">
          <span class="text-secondary">{{ selectedElement.name }}</span>
          <div v-if="!isSelectedElementHasHouse">
            <div v-if="isCountHousesLoading" class="placeholder-glow">
              <span class="placeholder"></span>
            </div>
            <span v-else>{{ countHouses }} {{ objectCase }}</span>
          </div>

          <transition name="fade">
            <div v-if="selectedElement.name" class="report-download-xls">
              <button @click="downloadSummaryReport" class="btn report-download">
                <span>Скачать сводный отчет</span>
                <img src="static-frontend/svg/excel-icon.svg" alt="file">
              </button>
            </div>
          </transition>
          <transition name="fade">
            <div v-if="selectedElement.name && isFullReportLinkExists" class="report-download-xls">
              <button @click="downloadFullReport" class="btn report-download">
                <span>Скачать детальный отчет</span>
                <img src="static-frontend/svg/excel-icon.svg" alt="file">
              </button>
            </div>
          </transition>
        </div>

      </div>
    </div>

    <div ref="collapse" class="collapse">
      <transition name="fade">
        <loader class="loader" v-if="isReportCreating"/>
        <div v-else class="report-result">

          <div class="input-with-cross">
            <label for="search-input" class="ic-search"></label>
            <input id="search-input" v-model="filterReportData" type="text" class="form-control"
                   placeholder="Поиск элемента">
            <span v-if="filterReportData" @click="filterReportData = ''" class="ic-cross"></span>
          </div>

          <div class="el-not-found" v-if="getReportData.length === 0"> Элементы у выбранных домов не добавлены</div>

          <div class="el-not-found" v-else-if="getFilteredReportData.length === 0"> Элементы не найдены</div>

          <elements-list v-else-if="filterReportData" class="filtered-house-elements"
                         :elements="getFilteredReportData"/>

          <accordion-elements v-else :elements="getReportData">
            <template v-slot:title="{element}">
              {{ element.name }}
              <span class="ic-archive"></span>
            </template>
            <template v-slot:body="{element}">
              <elements-list :elements="element.elements"/>
            </template>
          </accordion-elements>


        </div>
      </transition>

    </div>
  </div>
</template>

<script>
import ReportTree from "@/components/ReportTree"
import {Collapse} from "bootstrap"
import useReport from "@/composables/report/UseReport";
import Loader from "@/components/common/Loader";
import ElementsList from "@/components/crudElements/ElementsList";
import AccordionElements from "@/components/common/AccordionElements";

export default {
  name: "Report",
  components: {AccordionElements, ElementsList, Loader, ReportTree},
  setup() {
    return {
      ...useReport()
    }
  },
  mounted() {
    this.collapse = new Collapse(this.$refs.collapse, {toggle: false})
    this.clearReportState()
  },
  computed: {
    objectCase() {
      if (!this.countHouses) {
        return 'Объект не выбран'
      }

      const lastNumber = this.countHouses % 10

      if ([2, 3, 4].includes(lastNumber)) {
        return 'объекта'
      }
      if ([1].includes(lastNumber)) {
        return 'объект'
      }
      return 'объектов'
    },
    isSelectedElementHasHouse() {
      return this.selectedElement.id ? this.selectedElement.id.includes('houses') : false
    }
  },
  data() {
    return {
      selectedElement: {
        id: undefined,
        name: undefined,
        links: undefined
      },
      collapse: undefined,
      reportCreated: false
    }
  },
  methods: {
    onTreeClick(elId, el) {
      if (this.selectedElement.id === elId) {
        return
      }

      this.selectedElement.id = elId
      this.selectedElement.name = el.name
      this.selectedElement.links = el.links
      if (this.hasChild(el.links)) {
        this.getCountHouses(el.links)
      }
      this.createReport(this.selectedElement.links).then(() => {
        this.collapse.show()
        this.reportCreated = true
      })
    },
    showReport() {
      this.createReport(this.selectedElement.links).then(() => {
        this.collapse.show()
        this.reportCreated = true
      })
    },
    hasChild(links) {
      return Boolean(links.find(i => i.rel === 'children' && i.action === 'GET'))
    }
  }
}
</script>

<style lang="scss" scoped>
.report {

  .tree-text {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    position: relative;
    width: 100%;

    button {
      width: 100%;
      text-align: left;
    }

    &.selected {
      button {
        z-index: 1;
        cursor: default;
      }

      &:before {
        content: '';
        position: absolute;
        background: var(--common-background-frame);
        width: 100%;
        height: 100%;
        border-radius: 20px;
      }

    }
  }

  .report-object-info, .report-download-xls {
    border: 1px solid var(--default-icon-color);
    border-radius: 20px;
    padding: 1em;
    margin: .5em 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .report-object-info {
    display: flex;
    flex-direction: column;


    button {
      padding: 0;
      text-decoration: none;
    }

    .passports-count {
      margin-right: .5rem;
    }

    .placeholder-glow {
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: flex-start;

      .placeholder {
        width: 100%;
        height: 25px;
        border-radius: 5px;
      }
    }

    .create-report-btn {
      font-size: var(--main-font-size-text);
      display: flex;
      align-items: center;
      align-self: auto;

      span {
        margin-right: .5rem;
      }

      span.ic-add {
        color: var(--common-button);
      }


      &:disabled {
        background: transparent;
        border-color: transparent;

        span, span:hover {
          color: var(--default-icon-color);
        }
      }
    }
  }

  .report-download-xls {
    .report-download {
      font-size: var(--main-font-size-text);
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .report-result {
    margin-top: 1em;

    .report-download {
      color: #0468ff;
      text-decoration: none;
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
      align-items: center;
      margin: 10px 0;
      padding-left: 0;

      span {
        font-size: 1.3rem;
      }
    }

    .input-with-cross {
      position: relative;
      width: 100%;
      margin-bottom: .5em;

      input {
        padding-right: 30px;
        padding-left: 60px;
      }

      .ic-search {
        left: 14px;
        right: initial;
        cursor: default;

        &:hover {
          color: var(--default-icon-color);
        }
      }

      span, label {
        position: absolute;
        right: 7px;
        top: 3px;
        cursor: pointer;
        padding: 4px 8px;
      }
    }

    .filtered-house-elements {
      background-color: transparent;
      padding: 0.5rem 2rem;
      border-radius: 10px;
    }

    .el-not-found {
      text-align: center;
      padding: 10px 0;
    }
  }

  .collapse {
    min-height: 100px;

    .loader {
      position: absolute;
    }
  }
}

.ic-archive {
  color: var(--common-button);
}

@media (max-width: 769px) {
  .report .tree-text button {
    padding: 0.3em 0.7em;
  }
}
</style>
